import { render, staticRenderFns } from "./TicaoDetailPage.vue?vue&type=template&id=a39bd178&scoped=true"
import script from "./TicaoDetailPage.vue?vue&type=script&lang=js"
export * from "./TicaoDetailPage.vue?vue&type=script&lang=js"
import style0 from "./TicaoDetailPage.vue?vue&type=style&index=0&id=a39bd178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39bd178",
  null
  
)

export default component.exports